import { Button } from "@mui/material";

const UpdateClipButton = ({ children, onClick }) => (
  <Button
    variant="contained"
    disableElevation
    // disabled={isViewOnly}
    sx={{
      height: "30px",
      width: "42px",
      minWidth: "42px",
      color: "#606971",
      backgroundColor: "#F1F2F3",
      borderRadius: "8px",
      padding: "6px",
      fontSize: "13px",
      fontWeight: 600,
      lineHeight: "16px",
      // flex: 1,
      "&:hover": {
        backgroundColor: "#e7e9ea",
      },
      "&:active": {
        backgroundColor: "#e7e9ea",
      },
      "&:focus": {
        outline: "none",
      },
    }}
    size="small"
    onClick={onClick}
  >
    {children}
  </Button>
);

export default UpdateClipButton;
